var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.01C2 9.24859 4.23858 7.01001 7 7.01001H10C10.5523 7.01001 11 7.45772 11 8.01001C11 8.56229 10.5523 9.01001 10 9.01001H7C5.34315 9.01001 4 10.3532 4 12.01C4 13.6669 5.34315 15.01 7 15.01H10C10.5523 15.01 11 15.4577 11 16.01C11 16.5623 10.5523 17.01 10 17.01H7C4.23858 17.01 2 14.7714 2 12.01Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8.01001C13 7.45772 13.4477 7.01001 14 7.01001H17C19.7614 7.01001 22 9.24859 22 12.01C22 14.7714 19.7614 17.01 17 17.01H14C13.4477 17.01 13 16.5623 13 16.01C13 15.4577 13.4477 15.01 14 15.01H17C18.6569 15.01 20 13.6669 20 12.01C20 10.3532 18.6569 9.01001 17 9.01001H14C13.4477 9.01001 13 8.56229 13 8.01001Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.01C8 11.4577 8.44772 11.01 9 11.01H15C15.5523 11.01 16 11.4577 16 12.01C16 12.5623 15.5523 13.01 15 13.01H9C8.44772 13.01 8 12.5623 8 12.01Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.29f70ce7b74c742d0c86ebcff03368d2.svg";
export { ForwardRef as ReactComponent };